// Fix for hCaptcha frozen object error
if (window.Shopify && !window.Shopify.captcha) {
  window.Shopify = window.Shopify || {};
  window.Shopify.captcha = window.Shopify.captcha || {};
  
  // Only define protect if it doesn't exist
  if (typeof window.Shopify.captcha.protect === 'undefined') {
    Object.defineProperty(window.Shopify.captcha, 'protect', {
      value: function(form, callback) {
        // Your existing protection logic here
        if (callback && typeof callback === 'function') {
          callback();
        }
      },
      writable: true,
      configurable: true
    });
  }
}

// Prevent the original script from running if it's loaded later
Object.defineProperty(window, 'hcaptcha', {
  get: function() { return null; },
  set: function() {}
});
